import React, { useEffect, useState, useRef } from "react";
import { getKitchenItemsWithPassword, changeOrderItemStatus } from "../../../../services/Settings/Orderprocessing";
import { Box, Typography, CircularProgress, Alert, Avatar, useTheme, Divider, Button, Snackbar, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { changeOrderStatus } from "../../../../services/OrderStatus/OrderStatusApi";
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from "../../../../context/AuthContext";
import { useFeatures } from "../../../../context/PermissionsAndFeatures/FeaturesContext";
import WarningAmberIcon from '@mui/icons-material/WarningAmber'; // { changed code }


const TaghezScreen = () => {
  const { logout } = useAuth();
  const [kitchens, setKitchens] = useState([]); // Multiple kitchens
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [selectedTab, setSelectedTab] = useState("orders"); // "orders", "all", "kitchen", "category"
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedKitchen, setSelectedKitchen] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [orderSaving, setOrderSaving] = useState(false);
  const [confirmOrderDialog, setConfirmOrderDialog] = useState({ open: false, orderId: null });
  // استدعاء useFeatures مرة واحدة للحصول على الحالة والـ loading
  const { hasFeature, featuresLoading } = useFeatures();
  const showOrderPrepareConfirm = hasFeature("order_prepare_confirm");


  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";


   

  // مكوّن بسيط لعرض بادج العرض عندما يكون لدى الصنف رقم واسم عرض
  const OfferChip = ({ item }) => {
    if (!item) return null;
    const offerNumRaw = item.offer_;
    const offerNameRaw = item.offer_name;
    const hasOfferNum = offerNumRaw !== undefined && offerNumRaw !== null && String(offerNumRaw).trim() !== "";
    const hasOfferName = offerNameRaw !== undefined && offerNameRaw !== null && String(offerNameRaw).trim() !== "";
    if (!hasOfferNum || !hasOfferName) return null;
    const offerNum = String(offerNumRaw).trim();
    const offerName = String(offerNameRaw).trim();
    return (
      <Box
        sx={{
          mt: 1,
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          bgcolor: isDark ? "#ffecb3" : "#fff3bf",
          color: "#000",
          borderRadius: 1,
          px: 1.2,
          py: 0.4,
          fontWeight: 700,
          fontSize: "0.8rem",
          boxShadow: "0 1px 6px rgba(0,0,0,0.12)",
        }}
      >
        <Box sx={{ bgcolor: "#ff7043", color: "#fff", borderRadius: "6px", px: 0.7, py: 0.3, fontSize: "0.75rem", fontWeight: 900 }}>
          #{offerNum}
        </Box>
        <Box>{offerName}</Box>
      </Box>
    );
  };

  // مكوّن أيقونة تحذير يومض عند تجاوز وقت التجهيز
  const WarningBlink = ({ show }) => {
    if (!show) return null;
    return (
      <WarningAmberIcon
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          color: '#ffeb3b',
          fontSize: 32,
          zIndex: 5,
          animation: 'blink 1s infinite',
          '@keyframes blink': {
            '0%': { opacity: 1 },
            '50%': { opacity: 0 },
            '100%': { opacity: 1 },
          },
        }}
      />
    );
  };

  // حساب الوقت المنقضي
  const calculateElapsedTime = (openTime) => {
    if (!openTime) return "00:00:00";
    const [hours, minutes, seconds] = openTime.split(":").map(Number);
    const openDate = new Date();
    openDate.setHours(hours, minutes, seconds, 0);

    const now = new Date();
    let elapsed = Math.floor((now - openDate) / 1000);
    if (elapsed < 0) elapsed = 0;

    const elapsedHours = Math.floor(elapsed / 3600).toString().padStart(2, "0");
    const elapsedMinutes = Math.floor((elapsed % 3600) / 60).toString().padStart(2, "0");
    const elapsedSeconds = (elapsed % 60).toString().padStart(2, "0");

    return `${elapsedHours}:${elapsedMinutes}:${elapsedSeconds}`;
  };

  const formatTime = (time) => {
    if (!time) return "غير متوفر";
    const [hours, minutes, seconds] = time.split(":").map(Number);
    const date = new Date();
    date.setHours(hours, minutes, seconds, 0);

    const options = { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true };
    return date.toLocaleTimeString(undefined, options);
  };

  const fetchKitchenItems = async () => {
    try {
      const result = await getKitchenItemsWithPassword();
      // result.data هو مصفوفة من المطابخ
      const kitchensData = (result.data || []).map((kitchenObj) => {
        // أضف الوقت المنقضي لكل عنصر
        const grouped_items = {};
        Object.entries(kitchenObj.grouped_items || {}).forEach(([cat, items]) => {
          grouped_items[cat] = items.map((item) => {
            // حساب الوقت الفعلي لفتح العنصر اليوم
            let diffMinutes = null;
            let elapsedMinutes = null;
            if (item.open_time) {
              try {
                const [h, m, s] = item.open_time.split(":").map(Number);
                const dt = new Date();
                dt.setHours(h || 0, m || 0, s || 0, 0);
                const now = new Date();
                diffMinutes = Math.round((dt - now) / 60000); // دقائق حتى وقت التجهيز (قد تكون سالبة إذا مر الوقت)
                elapsedMinutes = Math.max(0, Math.round((now - dt) / 60000)); // دقائق مضت منذ وقت الفتح
              } catch (e) {
                diffMinutes = null;
                elapsedMinutes = null;
              }
            }
            const preparingMinutes = Number(item.preparing_time || 0);
            // تحذير قبل وقت التجهيز (قريب أو داخل النافذة) - فقط إذا لم يمر الوقت بعد
            const preparingAlert =
              diffMinutes !== null &&
              preparingMinutes > 0 &&
              diffMinutes <= preparingMinutes &&
              diffMinutes >= 0;
            // حالة تجاوز وقت التجهيز (البارزة المطلوبة)
            const overduePreparing =
              preparingMinutes > 0 &&
              elapsedMinutes !== null &&
              elapsedMinutes >= preparingMinutes;

            return {
              ...item,
              elapsedTime: calculateElapsedTime(item.open_time),
              diffMinutes,
              elapsedMinutes,
              preparingAlert,
              overduePreparing,
            };
          });
        });
        return {
          ...kitchenObj,
          grouped_items,
        };
      });
      setKitchens(kitchensData);
      setLastUpdated(new Date().toLocaleString());
    } catch (err) {
      setError(err.message || "فشل في جلب بيانات المطبخ.");
    } finally {
      setLoading(false);
    }
  };

  // زر تسليم الأوردر بالكامل
  const handleOrderStatusChange = async (orderId) => {
    setOrderSaving(true);
    try {
      await changeOrderStatus(orderId, "out_of_preparation");
      setSuccessMsg("✅ تم تسليم الأوردر بالكامل بنجاح");
      fetchKitchenItems();
    } catch (err) {
      setError(err.message || "❌ فشل في تسليم الأوردر بالكامل.");
    } finally {
      setOrderSaving(false);
      setConfirmOrderDialog({ open: false, orderId: null });
    }
  };

  // عند إنهاء تجهيز صنف
  const handleItemStatusChange = async (itemId) => {
    try {
      await changeOrderItemStatus(itemId);
      // بعد إنهاء تجهيز الصنف، جلب البيانات الجديدة
      await fetchKitchenItems();

      // بعد التحديث، تحقق إذا كان هذا آخر صنف في الأوردر
      // ابحث عن order_id لهذا الصنف
      let finishedOrderId = null;
      Object.values(groupedByOrderId).forEach((items) => {
        if (items.some((item) => item.id === itemId)) {
          finishedOrderId = items[0]?.order_id;
        }
      });

      if (finishedOrderId) {
        // تحقق إذا كان باقي أصناف لهذا الأوردر
        const remainingItems = (groupedByOrderId[finishedOrderId] || []).filter((item) => item.id !== itemId);
        if (remainingItems.length === 0) {
          setConfirmOrderDialog({ open: true, orderId: finishedOrderId });
        }
      }

      setSuccessMsg("✅ تم انتهاء التجهيز بنجاح");
    } catch (err) {
      setError(err.message || "❌ فشل في تغيير حالة العنصر.");
    }
  };

  // جلب البيانات فقط بعد تحميل الميزات وإذا كانت الميزة مفعّلة
  useEffect(() => {
    if (featuresLoading) return; // انتظر انتهاء تحميل الميزات
    if (!showOrderPrepareConfirm) return; // لا نفعل أي شيء إذا الميزة غير مفعّلة

    fetchKitchenItems();
    const interval = setInterval(fetchKitchenItems, 5000);
    return () => clearInterval(interval);
  }, [featuresLoading, showOrderPrepareConfirm]);

  // إضافة مرجع للصوت والتنبيه الصوتي
  const audioRef = useRef(null);
  const [audioInitialized, setAudioInitialized] = useState(false);

  useEffect(() => {
    // أنشئ كائن الصوت مرة واحدة عند تركيب المكوّن
    try {
      // مسار الملف الآن في مجلد public: /taghezalert.wav
      audioRef.current = new Audio(`${window.location.origin}/taghezalert.wav`);
      audioRef.current.loop = true; // لو ترغب بتشغيله مرة واحدة ضع false
      setAudioInitialized(true);
    } catch (e) {
      // صامت عند فشل تهيئة الصوت
      audioRef.current = null;
    }
    return () => {
      // تنظيف عند فك المكوّن
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, []);

  // راقب kitchens لتشغيل/إيقاف الصوت تلقائياً عند وجود أي صنف متجاوز
  useEffect(() => {
    if (!audioInitialized || !audioRef.current) return;
    // تحقق من وجود أي عنصر متجاوز الوقت
    const hasOverdue = kitchens.some((k) =>
      Object.values(k.grouped_items || {})
        .flat()
        .some((it) => !!it.overduePreparing)
    );

    if (hasOverdue) {
      // جرب تشغيل الصوت (قد يمنع المتصفح التشغيل التلقائي إذا لم يحدث تفاعل مستخدم)
      audioRef.current.play().catch(() => {
        // تجاهل الأخطاء (مثل حظر التشغيل التلقائي)، يمكن إظهار تلميح للمستخدم إذا أردت
      });
    } else {
      // إيقاف وإعادة تعيين
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  }, [kitchens, audioInitialized]);

  // منع عرض الصفحة أثناء تحميل ميزات المستخدم
  if (featuresLoading) return <CircularProgress />;
  // لو الميزة غير مفعلة: أظهر رسالة و زر تسجيل خروج
  if (!showOrderPrepareConfirm) {
    return (
      <Box
        sx={{
          p: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          bgcolor: isDark ? "#1c1c2b" : "#f5f5f5",
          color: isDark ? "#fff" : "#232334",
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Typography variant="h6" sx={{ textAlign: "center", mb: 2 }}>
          🚫 لا يمكنك الوصول إلى هذه الصفحة لأن ميزة "تأكيد التجهيز" غير مفعّلة في حسابك.
        </Typography>
        <Button
          variant="outlined"
          color="error"
          startIcon={<LogoutIcon />}
          onClick={() => logout && logout()}
        >
          تسجيل خروج
        </Button>
      </Box>
    );
  }
  
  // بعد التأكد من أن الميزات جاهزة والمِيزة مفعّلة، نكمل باقي العرض...

  if (loading) return <CircularProgress sx={{ display: "block", mx: "auto", mt: 4 }} />;
  if (error) return <Alert severity="error">{error}</Alert>;

  const subdomain = window.location.hostname.split(".")[0];
  const IMAGE_BASE_URL = `https://${subdomain}.restocash.app/`;
  const placeholderImage = "https://via.placeholder.com/300x140?text=No+Image";

  // حساب عدد الطلبات قيد التجهيز في جميع المطابخ
  const pendingOrdersCount = kitchens.reduce(
    (acc, kitchen) =>
      acc +
      Object.values(kitchen.grouped_items || {})
        .flat()
        .filter((item) => item.open_time).length,
    0
  );

  // تجميع العناصر حسب order_id
  const groupedByOrderId = {};
  kitchens.forEach((kitchen) => {
    Object.values(kitchen.grouped_items || {}).flat().forEach((item) => {
      if (!groupedByOrderId[item.order_id]) {
        groupedByOrderId[item.order_id] = [];
      }
      groupedByOrderId[item.order_id].push(item);
    });
  });

  const orderIds = Object.keys(groupedByOrderId);

  // جميع المطابخ
  const kitchenNames = kitchens.map((k) => k.kitchen);

  // جميع التصنيفات (categories)
  const allCategories = Array.from(
    kitchens.reduce((acc, kitchen) => {
      Object.keys(kitchen.grouped_items || {}).forEach((cat) => acc.add(cat));
      return acc;
    }, new Set())
  );

  // جميع الأصناف (بدون فلترة)
  const allItems = kitchens.flatMap((kitchen) =>
    Object.values(kitchen.grouped_items || {}).flat()
  );

  // أصناف حسب المطبخ المختار
  const itemsByKitchen = selectedKitchen
    ? kitchens
        .filter((k) => k.kitchen === selectedKitchen)
        .flatMap((k) => Object.values(k.grouped_items || {}).flat())
    : [];

  // أصناف حسب التصنيف المختار
  const itemsByCategory = selectedCategory
    ? kitchens.flatMap((k) =>
        Object.entries(k.grouped_items || {})
          .filter(([cat]) => cat === selectedCategory)
          .flatMap(([, items]) => items)
      )
    : [];

    
  return (
    <Box sx={{ p: 3, bgcolor: isDark ? "#1c1c2b" : "#f5f5f5", color: isDark ? "#fff" : "#232334", borderRadius: 2, boxShadow: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom sx={{ textAlign: "center", color: isDark ? "#f48fb1" : "#4caf50", flex: 1 }}>
          شاشة التجهيز
        </Typography>
 
        <Button
          variant="outlined"
          color="error"
          startIcon={<LogoutIcon />}
          onClick={() => logout && logout()}
          sx={{ ml: 2 }}
        >
          تسجيل خروج
        </Button>
      </Box>
      {/* تابات للأوردرات + تابة كل الأصناف + تابة المطابخ + تابة التصنيفات */}
      <Tabs
        value={
          selectedTab === "orders"
            ? (selectedOrderId || orderIds[0])
            : selectedTab === "all"
            ? "all"
            : selectedTab === "kitchen"
            ? `kitchen-${selectedKitchen}`
            : selectedTab === "category"
            ? `category-${selectedCategory}`
            : "all"
        }
        onChange={(_, v) => {
          if (v === "all") {
            setSelectedTab("all");
          } else if (v.startsWith("kitchen-")) {
            setSelectedTab("kitchen");
            setSelectedKitchen(v.replace("kitchen-", ""));
          } else if (v.startsWith("category-")) {
            setSelectedTab("category");
            setSelectedCategory(v.replace("category-", ""));
          } else {
            setSelectedTab("orders");
            setSelectedOrderId(v);
          }
        }}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 3, bgcolor: isDark ? "#232334" : "#e3f2fd", borderRadius: 2 }}
      >
        {/* أول تاب: كل الأصناف */}
        <Tab
          value="all"
          label="كل الأصناف"
          sx={{
            fontWeight: "bold",
            color: selectedTab === "all" ? "#1976d2" : undefined,
            bgcolor: selectedTab === "all" ? "#fff" : undefined,
            borderRadius: 2,
            mx: 1,
          }}
        />
        {/* ثاني تاب: المطابخ */}
        {kitchenNames.map((kitchen) => (
          <Tab
            key={kitchen}
            value={`kitchen-${kitchen}`}
            label={`مطبخ: ${kitchen}`}
            sx={{
              fontWeight: "bold",
              color: selectedTab === "kitchen" && selectedKitchen === kitchen ? "#1976d2" : undefined,
              bgcolor: selectedTab === "kitchen" && selectedKitchen === kitchen ? "#fff" : undefined,
              borderRadius: 2,
              mx: 1,
            }}
          />
        ))}
        {/* ثالث تاب: التصنيفات */}
        {allCategories.map((cat) => (
          <Tab
            key={cat}
            value={`category-${cat}`}
            label={`تصنيف: ${cat}`}
            sx={{
              fontWeight: "bold",
              color: selectedTab === "category" && selectedCategory === cat ? "#1976d2" : undefined,
              bgcolor: selectedTab === "category" && selectedCategory === cat ? "#fff" : undefined,
              borderRadius: 2,
              mx: 1,
            }}
          />
        ))}
        {/* باقي التابات: الأوردرات */}
        {orderIds.map((orderId) => (
          <Tab
            key={orderId}
            value={orderId}
            label={`طلب رقم ${orderId}`}
            sx={{
              fontWeight: "bold",
              color: selectedTab === "orders" && selectedOrderId === orderId ? "#1976d2" : undefined,
              bgcolor: selectedTab === "orders" && selectedOrderId === orderId ? "#fff" : undefined,
              borderRadius: 2,
              mx: 1,
            }}
          />
        ))}
      </Tabs>
      <Typography variant="h6" fontWeight={600} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555", mb: 2 }}>
        عدد الطلبات قيد التجهيز: {pendingOrdersCount}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
        <strong>تاريخ آخر تحديث:</strong> {lastUpdated || "جاري التحميل..."}
      </Typography>
      <Divider sx={{ mb: 3, borderColor: isDark ? "#444" : "#ddd" }} />

      {/* عرض الأصناف حسب التاب المختار */}
      {orderIds.length === 0 ? (
        <Typography variant="body1" sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
          لا توجد بيانات مطابخ.
        </Typography>
      ) : selectedTab === "all" ? (
        <Box sx={{ mb: 5, border: "2px solid #1976d2", borderRadius: 3, p: 2, background: isDark ? "#232334" : "#e3f2fd" }}>
          <Typography variant="h5" fontWeight={700} gutterBottom sx={{ color: isDark ? "#f48fb1" : "#1976d2" }}>
            كل الأصناف
          </Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: 3 }}>
            {allItems.map((item) => (
              <Box
                key={item.id}
                sx={{
                  p: 2,
                  border: "1px solid",
                  borderColor: isDark ? "#444" : "#ddd",
                  borderRadius: 2,
                  bgcolor: isDark ? "#2c2c3b" : "#fff",
                  boxShadow: 2,
                  position: 'relative', // { changed code }
                }}
              >
                <WarningBlink show={item.overduePreparing} /> {/* { changed code } */}
                <Avatar
                  src={item.image ? `${IMAGE_BASE_URL}${item.image.replace(/ /g, "%20")}` : placeholderImage}
                  alt={item.name}
                  sx={{ width: 80, height: 80, mb: 2, mx: "auto", boxShadow: 3 }}
                />
                {/* { changed code } */}
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mb: 1 }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ color: isDark ? "#fff" : "#232334" }}>
                    {item.name}
                  </Typography>
                  {item.preparing_time !== undefined && item.preparing_time !== null && (
                    <Box
                      sx={{
                        bgcolor: isDark ? "#ff7043" : "#fff3bf",
                        color: isDark ? "#000" : "#000",
                        borderRadius: 1,
                        px: 1,
                        py: 0.3,
                        fontWeight: 800,
                        fontSize: "0.85rem",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                      }}
                      title={`وقت التجهيز المحدد: ${Number(item.preparing_time)} دقيقة`}
                    >
                      {`${Number(item.preparing_time)} د`}
                    </Box>
                  )}
                </Box>
                {/* عرض بادج العرض إذا كان offer_ = 1 */}
                <OfferChip item={item} />
                {/* عرض الملاحظة إذا وجدت */}
                {item.note && (
                  <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#ff9800", fontWeight: 600 }}>
                    <strong>ملاحظة:</strong> {item.note}
                  </Typography>
                )}
                {/* عرض وصف المنتج إذا وجد */}
                {item.product_description && (
                  <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#1976d2", fontWeight: 600 }}>
                    <strong>الوصف:</strong> {item.product_description}
                  </Typography>
                )}
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#ff4d4f", fontWeight: 600 }}>
                  <strong>وقت الفتح:</strong> {formatTime(item.open_time)}
                </Typography>
                <Typography
                  variant="body2"
                  mb={1}
                  sx={{
                    textAlign: "center",
                    color: isDark ? "#4caf50" : "#1976d2",
                    fontWeight: 600,
                    fontSize: "1rem",
                  }}
                >
                  <strong>الوقت المنقضي:</strong> {item.elapsedTime}
                </Typography>
                {/* تحذير التجهيز استناداً إلى preparing_time */}
                {item.preparingAlert && (
                  <Box
                    sx={{
                      mt: 1,
                      fontWeight: "bold",
                      color: "#ffffff",
                      bgcolor: "#d84315",
                      borderRadius: "8px",
                      px: 2,
                      py: 0.5,
                      textAlign: "center",
                      boxShadow: "0 2px 8px rgba(216,67,21,0.2)",
                    }}
                  >
                    {typeof item.diffMinutes === "number"
                      ? item.diffMinutes > 0
                        ? `قريب من وقت التجهيز بعد ${item.diffMinutes} دقيقة`
                        : item.diffMinutes === 0
                        ? "وقت التجهيز الآن"
                        : `تجاوز وقت التجهيز منذ ${Math.abs(item.diffMinutes)} دقيقة`
                      : "قريب من وقت التجهيز"}
                  </Box>
                )}
                {item.overduePreparing && (
                  <Box
                    sx={{
                      mt: 1,
                      fontWeight: "900",
                      color: "#fff",
                      bgcolor: "#b71c1c",
                      borderRadius: "10px",
                      px: 2,
                      py: 1,
                      textAlign: "center",
                      boxShadow: "0 4px 12px rgba(183,28,28,0.25)",
                    }}
                  >
                    {`تجاوز وقت التجهيز منذ ${item.elapsedMinutes ?? 0} دقيقة — وقت التجهيز (المحدد للصنف): ${Number(item.preparing_time || 0)} دقيقة`}
                  </Box>
                )}
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>الكمية:</strong> {item.quantity}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>نوع الطلب:</strong> {item.order_type || "غير متوفر"}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>رقم الطاولة:</strong> {item.table_no || "غير متوفر"}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>رقم الطلب اليومي:</strong> {item.daily_increment}
                </Typography>
              
                <Button
                  variant="contained"
                  color="success"
                  sx={{ mt: 2, width: "100%" }}
                  onClick={() => handleItemStatusChange(item.id)}
                >
                  إنهاء التجهيز
                </Button>
              </Box>
            ))}
          </Box>
        </Box>
      ) : selectedTab === "kitchen" ? (
        <Box sx={{ mb: 5, border: "2px solid #1976d2", borderRadius: 3, p: 2, background: isDark ? "#232334" : "#e3f2fd" }}>
          <Typography variant="h5" fontWeight={700} gutterBottom sx={{ color: isDark ? "#f48fb1" : "#1976d2" }}>
            جميع الأصناف في مطبخ: {selectedKitchen}
          </Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: 3 }}>
            {itemsByKitchen.map((item) => (
              <Box
                key={item.id}
                sx={{
                  p: 2,
                  border: "1px solid",
                  borderColor: isDark ? "#444" : "#ddd",
                  borderRadius: 2,
                  bgcolor: isDark ? "#2c2c3b" : "#fff",
                  boxShadow: 2,
                  position: 'relative', // { changed code }
                }}
              >
                <WarningBlink show={item.overduePreparing} /> {/* { changed code } */}
                <Avatar
                  src={item.image ? `${IMAGE_BASE_URL}${item.image.replace(/ /g, "%20")}` : placeholderImage}
                  alt={item.name}
                  sx={{ width: 80, height: 80, mb: 2, mx: "auto", boxShadow: 3 }}
                />
                {/* { changed code } */}
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mb: 1 }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ color: isDark ? "#fff" : "#232334" }}>
                    {item.name}
                  </Typography>
                  {item.preparing_time !== undefined && item.preparing_time !== null && (
                    <Box
                      sx={{
                        bgcolor: isDark ? "#ff7043" : "#fff3bf",
                        color: isDark ? "#000" : "#000",
                        borderRadius: 1,
                        px: 1,
                        py: 0.3,
                        fontWeight: 800,
                        fontSize: "0.85rem",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                      }}
                      title={`وقت التجهيز المحدد: ${Number(item.preparing_time)} دقيقة`}
                    >
                      {`${Number(item.preparing_time)} د`}
                    </Box>
                  )}
                </Box>
                {/* عرض بادج العرض إذا كان offer_ = 1 */}
                <OfferChip item={item} />
                {/* عرض الملاحظة إذا وجدت */}
                {item.note && (
                  <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#ff9800", fontWeight: 600 }}>
                    <strong>ملاحظة:</strong> {item.note}
                  </Typography>
                )}
                {/* عرض وصف المنتج إذا وجد */}
                {item.product_description && (
                  <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#1976d2", fontWeight: 600 }}>
                    <strong>الوصف:</strong> {item.product_description}
                  </Typography>
                )}
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#ff4d4f", fontWeight: 600 }}>
                  <strong>وقت الفتح:</strong> {formatTime(item.open_time)}
                </Typography>
                <Typography
                  variant="body2"
                  mb={1}
                  sx={{
                    textAlign: "center",
                    color: isDark ? "#4caf50" : "#1976d2",
                    fontWeight: 600,
                    fontSize: "1rem",
                  }}
                >
                  <strong>الوقت المنقضي:</strong> {item.elapsedTime}
                </Typography>
                {/* تحذير التجهيز استناداً إلى preparing_time */}
                {item.preparingAlert && (
                  <Box
                    sx={{
                      mt: 1,
                      fontWeight: "bold",
                      color: "#ffffff",
                      bgcolor: "#d84315",
                      borderRadius: "8px",
                      px: 2,
                      py: 0.5,
                      textAlign: "center",
                      boxShadow: "0 2px 8px rgba(216,67,21,0.2)",
                    }}
                  >
                    {typeof item.diffMinutes === "number"
                      ? item.diffMinutes > 0
                        ? `قريب من وقت التجهيز بعد ${item.diffMinutes} دقيقة`
                        : item.diffMinutes === 0
                        ? "وقت التجهيز الآن"
                        : `تجاوز وقت التجهيز منذ ${Math.abs(item.diffMinutes)} دقيقة`
                      : "قريب من وقت التجهيز"}
                  </Box>
                )}
                {item.overduePreparing && (
                  <Box
                    sx={{
                      mt: 1,
                      fontWeight: "900",
                      color: "#fff",
                      bgcolor: "#b71c1c",
                      borderRadius: "10px",
                      px: 2,
                      py: 1,
                      textAlign: "center",
                      boxShadow: "0 4px 12px rgba(183,28,28,0.25)",
                    }}
                  >
                    {`تجاوز وقت التجهيز منذ ${item.elapsedMinutes ?? 0} دقيقة — وقت التجهيز (المحدد للصنف): ${Number(item.preparing_time || 0)} دقيقة`}
                  </Box>
                )}
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>الكمية:</strong> {item.quantity}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>نوع الطلب:</strong> {item.order_type || "غير متوفر"}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>رقم الطاولة:</strong> {item.table_no || "غير متوفر"}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>رقم الطلب اليومي:</strong> {item.daily_increment}
                </Typography>
               
                <Button
                  variant="contained"
                  color="success"
                  sx={{ mt: 2, width: "100%" }}
                  onClick={() => handleItemStatusChange(item.id)}
                >
                  إنهاء التجهيز
                </Button>
              </Box>
            ))}
          </Box>
        </Box>
      ) : selectedTab === "category" ? (
        <Box sx={{ mb: 5, border: "2px solid #1976d2", borderRadius: 3, p: 2, background: isDark ? "#232334" : "#e3f2fd" }}>
          <Typography variant="h5" fontWeight={700} gutterBottom sx={{ color: isDark ? "#f48fb1" : "#1976d2" }}>
            جميع الأصناف في التصنيف: {selectedCategory}
          </Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: 3 }}>
            {itemsByCategory.map((item) => (
              <Box
                key={item.id}
                sx={{
                  p: 2,
                  border: "1px solid",
                  borderColor: isDark ? "#444" : "#ddd",
                  borderRadius: 2,
                  bgcolor: isDark ? "#2c2c3b" : "#fff",
                  boxShadow: 2,
                  position: 'relative', // { changed code }
                }}
              >
                <WarningBlink show={item.overduePreparing} /> {/* { changed code } */}
                <Avatar
                  src={item.image ? `${IMAGE_BASE_URL}${item.image.replace(/ /g, "%20")}` : placeholderImage}
                  alt={item.name}
                  sx={{ width: 80, height: 80, mb: 2, mx: "auto", boxShadow: 3 }}
                />
                {/* { changed code } */}
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mb: 1 }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ color: isDark ? "#fff" : "#232334" }}>
                    {item.name}
                  </Typography>
                  {item.preparing_time !== undefined && item.preparing_time !== null && (
                    <Box
                      sx={{
                        bgcolor: isDark ? "#ff7043" : "#fff3bf",
                        color: isDark ? "#000" : "#000",
                        borderRadius: 1,
                        px: 1,
                        py: 0.3,
                        fontWeight: 800,
                        fontSize: "0.85rem",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                      }}
                      title={`وقت التجهيز المحدد: ${Number(item.preparing_time)} دقيقة`}
                    >
                      {`${Number(item.preparing_time)} د`}
                    </Box>
                  )}
                </Box>
                {/* عرض بادج العرض إذا كان offer_ = 1 */}
                <OfferChip item={item} />
                {/* عرض الملاحظة إذا وجدت */}
                {item.note && (
                  <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#ff9800", fontWeight: 600 }}>
                    <strong>ملاحظة:</strong> {item.note}
                  </Typography>
                )}
                {/* عرض وصف المنتج إذا وجد */}
                {item.product_description && (
                  <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#1976d2", fontWeight: 600 }}>
                    <strong>الوصف:</strong> {item.product_description}
                  </Typography>
                )}
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#ff4d4f", fontWeight: 600 }}>
                  <strong>وقت الفتح:</strong> {formatTime(item.open_time)}
                </Typography>
                <Typography
                  variant="body2"
                  mb={1}
                  sx={{
                    textAlign: "center",
                    color: isDark ? "#4caf50" : "#1976d2",
                    fontWeight: 600,
                    fontSize: "1rem",
                  }}
                >
                  <strong>الوقت المنقضي:</strong> {item.elapsedTime}
                </Typography>
                {/* تحذير التجهيز استناداً إلى preparing_time */}
                {item.preparingAlert && (
                  <Box
                    sx={{
                      mt: 1,
                      fontWeight: "bold",
                      color: "#ffffff",
                      bgcolor: "#d84315",
                      borderRadius: "8px",
                      px: 2,
                      py: 0.5,
                      textAlign: "center",
                      boxShadow: "0 2px 8px rgba(216,67,21,0.2)",
                    }}
                  >
                    {typeof item.diffMinutes === "number"
                      ? item.diffMinutes > 0
                        ? `قريب من وقت التجهيز بعد ${item.diffMinutes} دقيقة`
                        : item.diffMinutes === 0
                        ? "وقت التجهيز الآن"
                        : `تجاوز وقت التجهيز منذ ${Math.abs(item.diffMinutes)} دقيقة`
                      : "قريب من وقت التجهيز"}
                  </Box>
                )}
                {item.overduePreparing && (
                  <Box
                    sx={{
                      mt: 1,
                      fontWeight: "900",
                      color: "#fff",
                      bgcolor: "#b71c1c",
                      borderRadius: "10px",
                      px: 2,
                      py: 1,
                      textAlign: "center",
                      boxShadow: "0 4px 12px rgba(183,28,28,0.25)",
                    }}
                  >
                    {`تجاوز وقت التجهيز منذ ${item.elapsedMinutes ?? 0} دقيقة — وقت التجهيز (المحدد للصنف): ${Number(item.preparing_time || 0)} دقيقة`}
                  </Box>
                )}
                
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>الكمية:</strong> {item.quantity}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>نوع الطلب:</strong> {item.order_type || "غير متوفر"}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>رقم الطاولة:</strong> {item.table_no || "غير متوفر"}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>رقم الطلب اليومي:</strong> {item.daily_increment}
                </Typography>
                
                <Button
                  variant="contained"
                  color="success"
                  sx={{ mt: 2, width: "100%" }}
                  onClick={() => handleItemStatusChange(item.id)}
                >
                  إنهاء التجهيز
                </Button>
              </Box>
            ))}
          </Box>
        </Box>
      ) : (
        <Box sx={{ mb: 5, border: "2px solid #1976d2", borderRadius: 3, p: 2, background: isDark ? "#232334" : "#e3f2fd" }}>
          <Typography variant="h5" fontWeight={700} gutterBottom sx={{ color: isDark ? "#f48fb1" : "#1976d2" }}>
            الطلب رقم: {selectedOrderId || orderIds[0]}
          </Typography>
          <Button
            variant="contained"
            color="warning"
            sx={{ mb: 3, fontWeight: "bold" }}
            onClick={() => handleOrderStatusChange(selectedOrderId || orderIds[0])}
            disabled={orderSaving}
          >
            {orderSaving ? "جاري التسليم..." : "تسليم الأوردر بالكامل"}
          </Button>
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: 3 }}>
            {(groupedByOrderId[selectedOrderId || orderIds[0]] || []).map((item) => (
              <Box
                key={item.id}
                sx={{
                  p: 2,
                  border: "1px solid",
                  borderColor: isDark ? "#444" : "#ddd",
                  borderRadius: 2,
                  bgcolor: isDark ? "#2c2c3b" : "#fff",
                  boxShadow: 2,
                  position: 'relative', // { changed code }
                }}
              >
                <WarningBlink show={item.overduePreparing} /> {/* { changed code } */}
                <Avatar
                  src={item.image ? `${IMAGE_BASE_URL}${item.image.replace(/ /g, "%20")}` : placeholderImage}
                  alt={item.name}
                  sx={{ width: 80, height: 80, mb: 2, mx: "auto", boxShadow: 3 }}
                />
                {/* { changed code } */}
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mb: 1 }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ color: isDark ? "#fff" : "#232334" }}>
                    {item.name}
                  </Typography>
                  {item.preparing_time !== undefined && item.preparing_time !== null && (
                    <Box
                      sx={{
                        bgcolor: isDark ? "#ff7043" : "#fff3bf",
                        color: isDark ? "#000" : "#000",
                        borderRadius: 1,
                        px: 1,
                        py: 0.3,
                        fontWeight: 800,
                        fontSize: "0.85rem",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                      }}
                      title={`وقت التجهيز المحدد: ${Number(item.preparing_time)} دقيقة`}
                    >
                      {`${Number(item.preparing_time)} د`}
                    </Box>
                  )}
                </Box>
                {/* عرض بادج العرض إذا كان offer_ = 1 */}
                <OfferChip item={item} />
                {/* عرض الملاحظة إذا وجدت */}
                {item.note && (
                  <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#ff9800", fontWeight: 600 }}>
                    <strong>ملاحظة:</strong> {item.note}
                  </Typography>
                )}
                {/* عرض وصف المنتج إذا وجد */}
                {item.product_description && (
                  <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#1976d2", fontWeight: 600 }}>
                    <strong>الوصف:</strong> {item.product_description}
                  </Typography>
                )}
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: "#ff4d4f", fontWeight: 600 }}>
                  <strong>وقت الفتح:</strong> {formatTime(item.open_time)}
                </Typography>
                <Typography
                  variant="body2"
                  mb={1}
                  sx={{
                    textAlign: "center",
                    color: isDark ? "#4caf50" : "#1976d2",
                    fontWeight: 600,
                    fontSize: "1rem",
                  }}
                >
                  <strong>الوقت المنقضي:</strong> {item.elapsedTime}
                </Typography>
                {/* تحذير التجهيز استناداً إلى preparing_time */}
                {item.preparingAlert && (
                  <Box
                    sx={{
                      mt: 1,
                      fontWeight: "bold",
                      color: "#ffffff",
                      bgcolor: "#d84315",
                      borderRadius: "8px",
                      px: 2,
                      py: 0.5,
                      textAlign: "center",
                      boxShadow: "0 2px 8px rgba(216,67,21,0.2)",
                    }}
                  >
                    {typeof item.diffMinutes === "number"
                      ? item.diffMinutes > 0
                        ? `قريب من وقت التجهيز بعد ${item.diffMinutes} دقيقة`
                        : item.diffMinutes === 0
                        ? "وقت التجهيز الآن"
                        : `تجاوز وقت التجهيز منذ ${Math.abs(item.diffMinutes)} دقيقة`
                      : "قريب من وقت التجهيز"}
                  </Box>
                )}
                {item.overduePreparing && (
                  <Box
                    sx={{
                      mt: 1,
                      fontWeight: "900",
                      color: "#fff",
                      bgcolor: "#b71c1c",
                      borderRadius: "10px",
                      px: 2,
                      py: 1,
                      textAlign: "center",
                      boxShadow: "0 4px 12px rgba(183,28,28,0.25)",
                    }}
                  >
                    {`تجاوز وقت التجهيز منذ ${item.elapsedMinutes ?? 0} دقيقة — وقت التجهيز (المحدد للصنف): ${Number(item.preparing_time || 0)} دقيقة`}
                  </Box>
                )}
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>الكمية:</strong> {item.quantity}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>نوع الطلب:</strong> {item.order_type || "غير متوفر"}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>رقم الطاولة:</strong> {item.table_no || "غير متوفر"}
                </Typography>
                <Typography variant="body2" mb={1} sx={{ textAlign: "center", color: isDark ? "#aaa" : "#555" }}>
                  <strong>رقم الطلب اليومي:</strong> {item.daily_increment}
                </Typography>
               
                <Button
                  variant="contained"
                  color="success"
                  sx={{ mt: 2, width: "100%" }}
                  onClick={() => handleItemStatusChange(item.id)}
                >
                  إنهاء التجهيز
                </Button>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      {/* Dialog for last item in order */}
      <Dialog open={confirmOrderDialog.open} onClose={() => setConfirmOrderDialog({ open: false, orderId: null })}>
        <DialogTitle>تنبيه</DialogTitle>
        <DialogContent>
          <Typography>
            هذا آخر صنف في الأوردر بالكامل، هل تريد تغيير حالة الأوردر؟
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOrderDialog({ open: false, orderId: null })} color="secondary">
            لا
          </Button>
          <Button
            onClick={() => handleOrderStatusChange(confirmOrderDialog.orderId)}
            color="primary"
            variant="contained"
            disabled={orderSaving}
          >
            نعم، تغيير الحالة
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={!!successMsg}
        autoHideDuration={3000}
        onClose={() => setSuccessMsg("")}
      >
        <Alert severity="success">{successMsg}</Alert>
      </Snackbar>
      <Snackbar
        open={!!error}
        autoHideDuration={3000}
        onClose={() => setError("")}
      >
        <Alert severity="error">{error}</Alert>
      </Snackbar>
    </Box>
  );
};

export default TaghezScreen;